export const leading = {
  0: "1rem",
  1: "1rem",
  2: "1.25rem",
  3: "1.5rem",
  4: "1.5rem",
  5: "1.75rem",
  6: "2rem",
  7: "2.25rem",
  8: "2.5rem",
  9: "3.5rem",
  "code-0": "1.0rem",
  "code-1": "1.0rem",
  "code-2": "1.25rem",
  "code-3": "1.5rem",
  "code-4": "1.75rem",
  "code-5": "1.75rem",
  "code-6": "2.0rem",
  "code-7": "2.25rem",
  "code-8": "2.5rem",
  "code-9": "3.0rem",
};
